import MojitoCore from 'mojito/core';
import { STORE_KEY, initialState } from './slice.js';

const reduxInstance = MojitoCore.Services.redux;

/**
 * Match acca modules related selectors.
 *
 * @module MatchAccaSelectors
 * @name selectors
 * @memberof Mojito.Modules.MatchAcca
 */

/**
 * Selects match acca modules store state.
 *
 * @function selectState
 *
 * @param {object} [state] - Application state object. If not provided then state from global {@link Mojito.Core.Services.redux|redux store} will be returned.
 * @returns {Mojito.Modules.MatchAcca.MatchAccaState} Match acca modules store state.
 * @memberof Mojito.Modules.MatchAcca.selectors
 */
export const selectState = state => {
    // Should be no need to fallback to global state once fully migrated to Redux.
    const appState = state || reduxInstance.store?.getState();
    return appState?.[STORE_KEY] || initialState;
};

/**
 * Selects building state.
 *
 * @function selectIsBuilding
 *
 * @param {object} [state] - Application state object.
 * @returns {Mojito.Modules.MatchAcca.MatchAccaState} Match acca modules store state.
 * @memberof Mojito.Modules.MatchAcca.selectors
 */
export const selectIsBuilding = state => selectState(state).isBuilding;

/**
 * Selects event id.
 *
 * @function selectEventId
 *
 * @param {object} [state] - Application state object.
 * @returns {Mojito.Modules.MatchAcca.MatchAccaState} Match acca modules store state.
 * @memberof Mojito.Modules.MatchAcca.selectors
 */
export const selectEventId = state => selectState(state).eventId;

/**
 * Selects adding to betslip state.
 *
 * @function selectIsAddingToBetslip
 *
 * @param {object} [state] - Application state object.
 * @returns {Mojito.Modules.MatchAcca.MatchAccaState} Match acca modules store state.
 * @memberof Mojito.Modules.MatchAcca.selectors
 */
export const selectIsAddingToBetslip = state => selectState(state).isAddingToBetslip;
